import { render, staticRenderFns } from "./LiveBrief.vue?vue&type=template&id=54c4c16c&scoped=true&"
import script from "./LiveBrief.vue?vue&type=script&lang=js&"
export * from "./LiveBrief.vue?vue&type=script&lang=js&"
import style0 from "./LiveBrief.vue?vue&type=style&index=0&id=54c4c16c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4c16c",
  null
  
)

export default component.exports